/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MilestoneDto
 */
export interface MilestoneDto {
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneDto
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MilestoneDto
     */
    completedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneDto
     */
    sequence?: number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDto
     */
    priority?: string;
    /**
     * 
     * @type {number}
     * @memberof MilestoneDto
     */
    allocatedAmount?: number;
}

/**
 * Check if a given object implements the MilestoneDto interface.
 */
export function instanceOfMilestoneDto(value: object): value is MilestoneDto {
    return true;
}

export function MilestoneDtoFromJSON(json: any): MilestoneDto {
    return MilestoneDtoFromJSONTyped(json, false);
}

export function MilestoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MilestoneDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'completedDate': json['completedDate'] == null ? undefined : (new Date(json['completedDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'sequence': json['sequence'] == null ? undefined : json['sequence'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'assignee': json['assignee'] == null ? undefined : json['assignee'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'allocatedAmount': json['allocatedAmount'] == null ? undefined : json['allocatedAmount'],
    };
}

export function MilestoneDtoToJSON(json: any): MilestoneDto {
    return MilestoneDtoToJSONTyped(json, false);
}

export function MilestoneDtoToJSONTyped(value?: MilestoneDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'description': value['description'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'completedDate': value['completedDate'] == null ? undefined : ((value['completedDate']).toISOString()),
        'status': value['status'],
        'sequence': value['sequence'],
        'remarks': value['remarks'],
        'assignee': value['assignee'],
        'priority': value['priority'],
        'allocatedAmount': value['allocatedAmount'],
    };
}

